import { TFunction } from 'i18next';

export function getMinValueMessage(t: TFunction) {
	return ({ min }: { min: number }) => t('min_value', { min });
}
